import { render, staticRenderFns } from "./statements.vue?vue&type=template&id=2fa362cc&scoped=true&"
import script from "./statements.vue?vue&type=script&lang=js&"
export * from "./statements.vue?vue&type=script&lang=js&"
import style0 from "./statements.vue?vue&type=style&index=0&id=2fa362cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa362cc",
  null
  
)

export default component.exports